export const investTypes = [
  {
    id: "laboratory",
    name: "Laboratory Test",
  },
  {
    id: "radiology",
    name: "Radiology",
  },
  {
    id: "health",
    name: "Allied Health Services",
  },
  {
    id: "others",
    name: "Others",
  },
];
